export type WritingAssistantState = 'idle' | 'loading' | 'result' | 'tips' | 'error';

export const MIN_AI_DESCRIPTION_LENGTH = 100;
